<template>
  <modal :open="open" @close="close()" width="max-w-5xl">
    <template v-slot:modelcontent>
      <div class="sm:rounded-lg">
        <div class="mb-5">
          <h3 class="text-lg font-medium leading-6 text-gray-900">
            Asbestos Containing Materials
          </h3>
          <p class="mt-1 text-sm text-gray-500">
            Asbestos Containing Materials Information
          </p>
        </div>
        <template v-if="isOptionsLoaded && form">
          <div class="md:grid md:grid-cols-2 md:gap-6">
            <div class="md:col-span-1 col-span-2">
              <input-field
                  type="text"
                  label="Property Name"
                  name="property_name"
                  :errors="errors?.property_name"
                  v-model="form.property_name"
              />
            </div>
            <div class="md:col-span-1 col-span-2">
              <input-field
                  type="text"
                  label="Property UPRN"
                  name="property_uprn"
                  :errors="errors?.property_uprn"
                  v-model="form.property_uprn"
              />
            </div>
            <div class="md:col-span-1 col-span-2">
              <input-field
                  type="text"
                  label="Building"
                  name="building"
                  :errors="errors?.building"
                  required
                  v-model="form.building"
              />
            </div>
            <div class="md:col-span-1 col-span-2">
              <input-field
                  type="text"
                  label="Floor"
                  name="floor"
                  :errors="errors?.floor"
                  required
                  v-model="form.floor"
              />
            </div>
            <div class="md:col-span-1 col-span-2">
              <input-field
                  type="text"
                  label="Location Ref. Number"
                  name="location"
                  :errors="errors?.location"
                  v-model="form.location"
              />
            </div>
            <div class="md:col-span-1 col-span-2">
              <input-field
                  type="text"
                  label="Room"
                  name="room"
                  :errors="errors?.room"
                  required
                  v-model="form.room"
              />
            </div>
            <div class="md:col-span-1 col-span-2">
              <input-field
                  type="file"
                  label="Photo"
                  name="acm_file"
                  :errors="errors?.acm_file"
                  required
                  v-model="form.acm_file"
              />
              <div v-if="form.current_document_data">
                <a
                    target="_blank"
                    :href="form.current_document_data.file_path"
                >{{ form.current_document_data.name }}</a>
              </div>
            </div>
            <div class="md:col-span-1 col-span-2">
              <input-field
                  type="text"
                  label="Reference No."
                  name="reference"
                  :errors="errors?.reference"

                  v-model="form.reference"
              />
            </div>
            <div class="md:col-span-1 col-span-2">
              <input-field
                  type="text"
                  label="Sample No."
                  name="sample_number"
                  :errors="errors?.sample_number"
                  v-model="form.sample_number"
              />
            </div>
            <div class="md:col-span-1 col-span-2">
              <textarea-field
                  label="ACM Type"
                  name="acm_type"
                  :errors="errors?.acm_type"
                  required
                  v-model="form.acm_type"
              />
            </div>
            <div class="md:col-span-1 col-span-2">
              <input-field
                  type="text"
                  label="Amount"
                  name="amount"
                  :errors="errors?.amount"
                  v-model="form.amount"
              />
            </div>
            <div class="md:col-span-1 col-span-2">
              <select-flat-field
                  label="(Unit) Amount"
                  name="amount_unit"
                  :options="amount_units"
                  :errors="errors?.amount_unit"
                  v-model="form.amount_unit"
              />
            </div>
            <div class="md:col-span-1 col-span-2">
              <input-field
                  type="text"
                  label="Unique ACM Number"
                  name="unique_acm_number"
                  :errors="errors?.unique_acm_number"
                  v-model="form.unique_acm_number"
              />
            </div>
            <div class="md:col-span-1 col-span-2">
              <input-field
                  type="text"
                  label="ACM Location in Room"
                  name="acm_location_room"
                  :errors="errors?.acm_location_room"
                  v-model="form.acm_location_room"
              />
            </div>
          </div>
          <div class="mt-5 mb-5">
            <hr>
            <h2 class="mt-1"><b>Material Risk Assessment</b></h2>
          </div>
          <div class="md:grid md:grid-cols-2 md:gap-6">
            <div class="md:col-span-1 col-span-2">
              <input-field
                  type="text"
                  label="Product Type"
                  name="product_type"
                  :errors="errors?.product_type"
                  v-model="form.product_type"
              />
            </div>
            <div class="md:col-span-1 col-span-2">
              <input-field
                  type="text"
                  label="Product Type Score"
                  name="product_type_score"
                  :errors="errors?.product_type_score"
                  v-model="form.product_type_score"
              />
            </div>
            <div class="md:col-span-1 col-span-2">
              <v-select-field
                  label="Asbestos Fibre Type"
                  name="fibre_type[]"
                  multiple
                  :options="fibreTypeOptions"
                  option-label="label"
                  :transform="o => o.value"
                  :errors="errors?.fibre_type"
                  required
                  v-model="form.fibre_type"
              />
            </div>
            <div class="md:col-span-1 col-span-2">
              <input-field
                  type="text"
                  label="Asbestos Fibre Type Score"
                  name="asbestos_fibre_type_score"
                  :errors="errors?.asbestos_fibre_type_score"
                  v-model="form.asbestos_fibre_type_score"
              />
            </div>
            <div class="md:col-span-1 col-span-2">
              <select-flat-field
                  label="Condition"
                  name="condition"
                  :options="conditions"
                  :errors="errors?.condition"

                  v-model="form.condition"
              />
            </div>
            <div class="md:col-span-1 col-span-2">
              <input-field
                  type="text"
                  label="Condition Score"
                  name="condition_score"
                  :errors="errors?.condition_score"
                  v-model="form.condition_score"
              />
            </div>
            <div class="md:col-span-1 col-span-2">
              <input-field
                  type="text"
                  label="Surface Treatment"
                  name="surface_treatment"
                  :errors="errors?.surface_treatment"
                  v-model="form.surface_treatment"
              />
            </div>
            <div class="md:col-span-1 col-span-2">
              <input-field
                  type="text"
                  label="Surface Treatment Score"
                  name="surface_treatment_score"
                  :errors="errors?.surface_treatment_score"
                  v-model="form.surface_treatment_score"
              />
            </div>
          </div>
          <div class="md:grid md:grid-cols-2 md:gap-6 mt-5 flex items-center">
            <div><b>Material Risk Assessment Score</b></div>
            <div class="md:col-span-1 col-span-2">
              <input-field
                  type="number"
                  name="material_risk_assessment"
                  :errors="errors?.material_risk_assessment"
                  v-model="form.material_risk_assessment"
              />
            </div>
          </div>
          <div class="mt-5 mb-5">
            <hr>
          </div>
          <div class="md:grid md:grid-cols-2 md:gap-6">
            <div class="md:col-span-1 col-span-2">
              <input-field
                  type="text"
                  label="Accessibility"
                  name="accessibility"
                  :errors="errors?.accessibility"
                  v-model="form.accessibility"
              />
            </div>
          </div>
          <div class="mt-5 mb-5">
            <hr>
            <h2 class="mt-1"><b>Priority Risk Assessment</b></h2>
          </div>
          <div class="mt-5 mb-5">
            <h2 class="mt-1">Normal Occupancy Activity</h2>
          </div>
          <div class="md:grid md:grid-cols-2 md:gap-6">
            <div class="md:col-span-1 col-span-2">
              <input-field
                  type="text"
                  label="Main Activity"
                  name="main_activity"
                  :errors="errors?.main_activity"
                  v-model="form.main_activity"
              />
            </div>
            <div class="md:col-span-1 col-span-2">
              <input-field
                  type="text"
                  label="Main Activity Score"
                  name="main_activity_score"
                  :errors="errors?.main_activity_score"
                  v-model="form.main_activity_score"
              />
            </div>
            <div class="md:col-span-1 col-span-2">
              <input-field
                  type="text"
                  label="Secondary Activity"
                  name="secondary_activity"
                  :errors="errors?.secondary_activity"
                  v-model="form.secondary_activity"
              />
            </div>
            <div class="md:col-span-1 col-span-2">
              <input-field
                  type="text"
                  label="Secondary Activity Score"
                  name="secondary_activity_score"
                  :errors="errors?.secondary_activity_score"
                  v-model="form.secondary_activity_score"
              />
            </div>
          </div>
          <div class="md:grid md:grid-cols-2 md:gap-6 mt-5 flex items-center">
            <div>Normal Occupancy Activity Ave. Score</div>
            <div class="md:col-span-1 col-span-2">
              <input-field
                  type="text"
                  name="noa_average_score"
                  :errors="errors?.noa_average_score"
                  v-model="form.noa_average_score"
              />
            </div>
          </div>
          <div class="mt-5 mb-5">
            <h2 class="mt-1">Likelihood of Disturbance</h2>
          </div>
          <div class="md:grid md:grid-cols-2 md:gap-6">
            <div class="md:col-span-1 col-span-2">
              <input-field
                  type="text"
                  label="Location"
                  name="location_type"
                  :errors="errors?.location_type"
                  v-model="form.location_type"
              />
            </div>
            <div class="md:col-span-1 col-span-2">
              <input-field
                  type="text"
                  label="Location Score"
                  name="location_score"
                  :errors="errors?.location_score"
                  v-model="form.location_score"
              />
            </div>
            <div class="md:col-span-1 col-span-2">
              <input-field
                  type="text"
                  label="Accessibility"
                  name="accessibility_pra"
                  :errors="errors?.accessibility_pra"
                  v-model="form.accessibility_pra"
              />
            </div>
            <div class="md:col-span-1 col-span-2">
              <input-field
                  type="text"
                  label="Accessibility Score"
                  name="accessibility_pra_score"
                  :errors="errors?.accessibility_pra_score"
                  v-model="form.accessibility_pra_score"
              />
            </div>
            <div class="md:col-span-1 col-span-2">
              <input-field
                  type="text"
                  label="Extent / Amount"
                  name="extent_amount"
                  :errors="errors?.extent_amount"
                  v-model="form.extent_amount"
              />
            </div>
            <div class="md:col-span-1 col-span-2">
              <input-field
                  type="text"
                  label="Extent / Amount Score"
                  name="extent_amount_score"
                  :errors="errors?.extent_amount_score"
                  v-model="form.extent_amount_score"
              />
            </div>
          </div>
          <div class="md:grid md:grid-cols-2 md:gap-6 mt-5 flex items-center">
            <div>Likelihood of Disturbance Ave. Score</div>
            <div class="md:col-span-1 col-span-2">
              <input-field
                  type="text"
                  name="lod_average_score"
                  :errors="errors?.lod_average_score"
                  v-model="form.lod_average_score"
              />
            </div>
          </div>
          <div class="mt-5 mb-5">
            <h2 class="mt-1">Human Exposure Potential</h2>
          </div>
          <div class="md:grid md:grid-cols-2 md:gap-6">
            <div class="md:col-span-1 col-span-2">
              <input-field
                  type="text"
                  label="Number Of Occupants"
                  name="number_of_occupants"
                  :errors="errors?.number_of_occupants"
                  v-model="form.number_of_occupants"
              />
            </div>
            <div class="md:col-span-1 col-span-2">
              <input-field
                  type="text"
                  label="Number Of Occupants Score"
                  name="number_of_occupants_score"
                  :errors="errors?.number_of_occupants_score"
                  v-model="form.number_of_occupants_score"
              />
            </div>
            <div class="md:col-span-1 col-span-2">
              <input-field
                  type="text"
                  label="Freq. Of Use Area"
                  name="frequency_of_use_of_area"
                  :errors="errors?.frequency_of_use_of_area"
                  v-model="form.frequency_of_use_of_area"
              />
            </div>
            <div class="md:col-span-1 col-span-2">
              <input-field
                  type="text"
                  label="Freq. Of Use Area Score"
                  name="frequency_of_use_of_area_score"
                  :errors="errors?.frequency_of_use_of_area_score"
                  v-model="form.frequency_of_use_of_area_score"
              />
            </div>
            <div class="md:col-span-1 col-span-2">
              <input-field
                  type="text"
                  label="Average Time Area In Use"
                  name="average_time_area_in_use"
                  :errors="errors?.average_time_area_in_use"
                  v-model="form.average_time_area_in_use"
              />
            </div>
            <div class="md:col-span-1 col-span-2">
              <input-field
                  type="text"
                  label="Average Time Area In Use Score"
                  name="average_time_area_in_use_score"
                  :errors="errors?.average_time_area_in_use_score"
                  v-model="form.average_time_area_in_use_score"
              />
            </div>
          </div>
          <div class="md:grid md:grid-cols-2 md:gap-6 mt-5 flex items-center">
            <div>Human Exposure Potential Ave. Score</div>
            <div class="md:col-span-1 col-span-2">
              <input-field
                  type="text"
                  name="hep_average_score"
                  :errors="errors?.hep_average_score"
                  v-model="form.hep_average_score"
              />
            </div>
          </div>
          <div class="mt-5 mb-5">
            <h2 class="mt-1">Maintenance Activity</h2>
          </div>
          <div class="md:grid md:grid-cols-2 md:gap-6">
            <div class="md:col-span-1 col-span-2">
              <input-field
                  type="text"
                  label="Type Of Maintenance Activity"
                  name="type_of_maintenance_activity"
                  :errors="errors?.type_of_maintenance_activity"
                  v-model="form.type_of_maintenance_activity"
              />
            </div>
            <div class="md:col-span-1 col-span-2">
              <input-field
                  type="text"
                  label="Type Of Maintenance Activity Score"
                  name="type_of_maintenance_activity_score"
                  :errors="errors?.type_of_maintenance_activity_score"
                  v-model="form.type_of_maintenance_activity_score"
              />
            </div>
            <div class="md:col-span-1 col-span-2">
              <input-field
                  type="text"
                  label="Frequence Of Maintenance Activity"
                  name="frequency_of_maintenance_activity"
                  :errors="errors?.frequency_of_maintenance_activity"
                  v-model="form.frequency_of_maintenance_activity"
              />
            </div>
            <div class="md:col-span-1 col-span-2">
              <input-field
                  type="text"
                  label="Frequence Of Maintenance Activity Score"
                  name="frequency_of_maintenance_activity_score"
                  :errors="errors?.frequency_of_maintenance_activity_score"
                  v-model="form.frequency_of_maintenance_activity_score"
              />
            </div>
          </div>
          <div class="md:grid md:grid-cols-2 md:gap-6 mt-5 flex items-center">
            <div>Maintenance Activity Average Score</div>
            <div class="md:col-span-1 col-span-2">
              <input-field
                  type="text"
                  name="maint_activity_average_score"
                  :errors="errors?.maint_activity_average_score"
                  v-model="form.maint_activity_average_score"
              />
            </div>
          </div>
          <div class="md:grid md:grid-cols-2 md:gap-6 mt-5 flex items-center">
            <div><b>Priority Risk Assessment Score</b></div>
            <div class="md:col-span-1 col-span-2">
              <input-field
                  type="number"
                  name="priority_risk_assessment"
                  :errors="errors?.priority_risk_assessment"
                  v-model="form.priority_risk_assessment"
              />
            </div>
          </div>
          <div class="mt-5 mb-5">
            <hr>
          </div>
          <div class="md:grid md:grid-cols-2 md:gap-6 mb-5 flex items-center">
            <div><b>Total Risk Assessment Score</b></div>
            <div class="md:col-span-1 col-span-2">
              <input-field
                  type="number"
                  name="total_ra_score"
                  :errors="errors?.total_ra_score"
                  v-model="form.total_ra_score"
              />
            </div>
          </div>
          <div class="md:grid md:grid-cols-2 md:gap-6">
            <div class="md:col-span-1 col-span-2">
              <select-flat-field
                  label="Risk Rating"
                  name="risk_rating"
                  :options="risk_ratings"
                  :errors="errors?.risk_rating"
                  v-model="form.risk_rating"
              />
            </div>
            <div class="md:col-span-1 col-span-2">
              <input-field
                  type="date"
                  label="Action / Review Date"
                  name="action_date"
                  :errors="errors?.action_date"
                  v-model="form.action_date"
              />
            </div>
            <div class="md:col-span-1 col-span-2">
              <textarea-field
                  label="Recommendation"
                  name="recommendation"
                  :errors="errors?.recommendation"
                  v-model="form.recommendation"
              />
            </div>
            <div class="md:col-span-1 col-span-2">
              <select-flat-field
                  label="Status" name="status"
                  :options="statuses"
                  :errors="errors?.status"
                  required
                  v-model="form.status"
              />
            </div>
          </div>
          <div class="mt-5 mb-5">
            <hr>
          </div>
          <div class="md:grid md:grid-cols-2 md:gap-6">
            <div class="md:col-span-1 col-span-2">
              <input-field
                  type="text"
                  label="Spare 1"
                  name="spare_1"
                  :errors="errors?.spare_1"
                  v-model="form.spare_1"
              />
            </div>
            <div class="md:col-span-1 col-span-2">
              <input-field
                  type="text"
                  label="Spare 2"
                  name="spare_2"
                  :errors="errors?.spare_2"
                  v-model="form.spare_2"
              />
            </div>
            <div class="md:col-span-1 col-span-2">
              <input-field
                  type="text"
                  label="Spare 3"
                  name="spare_3"
                  :errors="errors?.spare_3"
                  v-model="form.spare_3"
              />
            </div>
            <div class="md:col-span-1 col-span-2">
              <input-field
                  type="text"
                  label="Spare 4"
                  name="spare_4"
                  :errors="errors?.spare_4"
                  v-model="form.spare_4"
              />
            </div>
            <div class="md:col-span-1 col-span-2">
              <input-field
                  type="text"
                  label="Spare 5"
                  name="spare_5"
                  :errors="errors?.spare_5"
                  v-model="form.spare_5"
              />
            </div>
          </div>
        </template>
      </div>

      <div class="flex justify-end mt-5">
        <cancel-button :disabled="isLoading" @click="close()"/>
        <save-button :disabled="isLoading" @click="handleSaveClick()"/>
      </div>
    </template>
  </modal>
</template>

<script>
import VSelectField from "../components/form/VSelectField";

export default {
  name: 'AcmModal',
  components: {VSelectField},
  props: {
    registerId: {
      type: String,
      required: true
    },
    open: {
      type: Boolean,
      required: true,
      default: true
    },
    selectedItem: {
      type: Object
    }
  },

  watch: {
    open(newVal) {
      this.errors = null;

      if (newVal && !this.selectedItem) {
        this.loadFormOptions();
      }

      if (newVal && this.selectedItem) {
        this.loadData();
      }

      if (newVal && !this.selectedItem) {
        this.form = this.getEmpty();
      }
    }
  },

  data() {
    return {
      errors: null,
      form: this.getEmpty(),
      isLoading: false,
      isOptionsLoaded: false,
      conditions: [],
      statuses: [],
      fibre_types: [],
      amount_units: [],
      risk_ratings: []
    }
  },

  computed: {
    fibreTypeOptions() {
      const types = [];
      for (const type in this.fibre_types) {
        types.push({
          label: this.fibre_types[type],
          value: type
        })
      }

      return types;
    }
  },

  methods: {
    setErrors(error) {
      if (error.response.status === 422) {
        this.errors = error.response.data.errors
      } else {
        this.$emit('error', error)
      }
    },

    handleSaveClick() {
      const formData = new FormData();
      this.buildFormData(formData, this.form);

      if (this.selectedItem)
        this.update(formData);
      else
        this.create(formData);
    },

    create(formData) {
      axios.post(route('ajax.register.acm.create', [this.registerId]), formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
          .then(response => {
            this.$emit('created', response);
            this.isOptionsLoaded = false;
            this.form = this.getEmpty();
          })
          .catch(error => {
            this.setErrors(error);
          })
    },

    update(formData) {
      axios.post(route('ajax.register.acm.update', [this.registerId, this.selectedItem.id]),
          formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          .then(response => {
            this.$emit('updated', response);
            this.isOptionsLoaded = false;
            this.form = this.getEmpty();
          })
          .catch(error => {
            this.setErrors(error);
          })
    },

    close: function () {
      this.isOptionsLoaded = false;
      this.form = this.getEmpty();
      this.$emit('closed');
    },

    loadData() {
      this.isLoading = true;
      axios.get(route('ajax.register.acm.view', [this.registerId, this.selectedItem.id]))
          .then(response => {
            this.form = response.data;

            if (!this.isOptionsLoaded) {
              this.loadFormOptions();
            }
          })
          .catch(error => {
            this.setErrors(error)
          })
          .finally(() => {
            this.isLoading = false;
          })
    },

    loadFormOptions() {
      axios.get(route('ajax.register.acm.form-options', this.registerId))
          .then(response => {
            this.conditions = response.data.conditions;
            this.statuses = response.data.statuses;
            this.fibre_types = response.data.fibre_types;
            this.amount_units = response.data.amount_units;
            this.risk_ratings = response.data.risk_ratings;

            this.isOptionsLoaded = true;
          })
    },

    getEmpty() {
      return {
        acm_file: null,
        reference: '',
        sample_number: '',
        location: '',
        building: '',
        floor: '',
        room: '',
        acm_type: '',
        condition: null,
        fibre_type: [],
        surface_treatment: '',
        amount_unit: null,
        accessibility: '',
        material_risk_assessment: '',
        priority_risk_assessment: '',
        total_ra_score: '',
        risk_rating: '',
        recommendation: '',
        action_date: '',
        status: null,
        current_document_data: null
      }
    }
  }
}
</script>
